import { useState } from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Button } from '@mentimeter/ragnar-ui/button';
import { List } from '@mentimeter/ragnar-ui/list';
import { Text } from '@mentimeter/ragnar-ui/text';
import { Image } from '@mentimeter/ragnar-ui/image';
import {
  ModalRoot,
  ModalContainer,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@mentimeter/ragnar-ui/modal';
import uploadFallbackErrorImg from './image_fallback_error_editor.svg';

export const ErrorFallback = () => {
  const [show, setShow] = useState(true);
  return (
    <ModalRoot open={show} onOpenChange={setShow}>
      <ModalContainer flexDirection="row">
        <Box
          width="40%"
          alignItems="center"
          justifyContent="center"
          bg="neutralWeakest"
          display={['none', null, 'flex']}
        >
          <Image
            src={uploadFallbackErrorImg.src}
            alt="Error occurred"
            my={3}
            width="200px"
          />
        </Box>
        <Box alignItems="stretch" flex="1 1 auto">
          <ModalHeader>There&apos;s a bit of a glitch</ModalHeader>
          <ModalBody>
            <Text color="text">
              We&apos;re sorry, it looks like something went wrong on our end.
              Let&apos;s try a few things to get you back on track:
              <List ml={2} mt={2}>
                <Text as="li" pl={1} ml={3} color="text">
                  <strong>Reload</strong> the page
                </Text>
                <Text as="li" pl={1} ml={3} color="text">
                  Check that you&apos;re connected to the network
                </Text>
                <Text as="li" pl={1} ml={3} mb={2} color="text">
                  <strong>Go back</strong> to the last saved page
                </Text>
              </List>
              If that doesn&apos;t work, <strong>drop us a line</strong> and
              we&apos;ll figure it out together.
            </Text>
          </ModalBody>
          <ModalFooter>
            <Button onClick={() => window.location.reload()} size="compact">
              Reload
            </Button>
          </ModalFooter>
        </Box>
      </ModalContainer>
    </ModalRoot>
  );
};
